import { Skeleton } from '@/components/ui/skeleton';

interface ChartSkeletonLoaderProps {
  height?: number | string;
}

export function ChartSkeletonLoader({ height = 240 }: ChartSkeletonLoaderProps) {
  return <Skeleton className="w-full rounded-lg" style={{ height }} />;
}
